module.exports = __webpack_public_path__ + "static/media/banner.a15b167b.jpg";